// extracted by mini-css-extract-plugin
module.exports = {"notfound":"notfound_notfound__2nLQ5"};